var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tab-item',_vm._b({},'v-tab-item',_vm.$props,false),[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }